// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + "b85abf17e98847c6e002" + ".css";
};